/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { NgForKeyDirective } from '../../directives/ng-for-track-by-id.directive';

export interface KebabAction<T = any> {
	label: string | ((row: T) => string);
	ariaLabel?: string;
	menuIcon?: string;
	onClick?: (row: T) => void;
	hidden?: (row: T) => boolean;
	disabled?: (row: T) => boolean;
	disabledMessage?: string | ((row: T) => string);
	href?: string | ((row: T) => string);
}

@Component({
	selector: 'sl-kebab',
	templateUrl: './kebab.component.html',
	styleUrls: ['./kebab.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [MatButtonModule, MatMenuModule, MatIconModule, NgFor, NgForKeyDirective, MatTooltipModule, NgTemplateOutlet, RouterLink, NgIf],
})
export class KebabComponent implements OnChanges {
	@Input()
	actions: KebabAction[] = [];

	@Input()
	entity: any;

	@Input()
	label = '';

	@Input()
	icon = 'more_vert';

	visibleActions: KebabAction[] = [];

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.actions?.currentValue) {
			this.visibleActions = this.actions.filter((item) => (item.hidden ? !item.hidden(this.entity) : true));
		}
	}

	isFunction(value: any) {
		return typeof value === 'function';
	}
}
